import Vue from "vue";
import App from "@/App";

import { clickOutside } from "@/directives";
import "@/registerServiceWorker";
import router from "@/router";
import store from "@/store";

import { STAGE } from "@/app.config";

Vue.config.devtools = STAGE !== "prod";
Vue.config.ignoredElements = [/^ion-/];
Vue.config.productionTip = false;

Vue.directive("click-outside", clickOutside);

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount("#app");

document.body.addEventListener("keyup", event => {
  const isTabKey = event.which === 9;
  const eventInForm = event.target.form;

  if (isTabKey && !eventInForm) {
    document.documentElement.classList.remove("no-focus-outline");
  }
});
